import { BaseChatClient } from "../types/clients";
class ChatClient extends BaseChatClient {}
export default ChatClient;
